import { render } from "./Bottles.vue?vue&type=template&id=b9d243ac&scoped=true"
import script from "./Bottles.vue?vue&type=script&lang=js"
export * from "./Bottles.vue?vue&type=script&lang=js"

import "./Bottles.vue?vue&type=style&index=0&id=b9d243ac&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9d243ac"]])

export default __exports__